export default "__VITE_ASSET__Crs7O8ig__"